/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { DefaultTheme } from 'styled-components';
import { CSSProperties, ReactNode, ComponentType } from 'react';

export interface BoxProps extends CSSProperties {
  as?: string | ComponentType<unknown>;
  children?: ReactNode;
  theme?: DefaultTheme;
}

const getStyleProps = ({ as, children, theme, ...rawStyleProps }: BoxProps) => {
  return rawStyleProps;
};

export const Box = styled.div<BoxProps>(getStyleProps);
